
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateWelcomescreenDtoFormGroup() {
return new FormGroup({
    secret: new FormControl<string | undefined>(''),
    mediafileId: new FormControl<number | undefined>(undefined, [Validators.required]),
    templateElementId: new FormControl<number | undefined>(undefined, [Validators.required]),
    text: new FormControl<string | undefined>('', [Validators.required]),
})
;
}
      